import React, { useEffect, useState } from 'react';
import { FournisseurService } from '../../../../services/FournisseurService';
import { Form, Spinner, Card, Tabs, Table, Tab, Row, Col, Accordion, Button, OverlayTrigger, Alert, Tooltip, Dropdown, Badge } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import ErrorManager from "../../../error-manager/ErrorManager";
import { getFormErrorMsg } from '../../../../helper/Helper'
//import './FournisseurDetails.scss';
import TextArrayInput from "../../../form-inputs/text-array-input/TextArrayInput";
import { BrouillonService } from '../../../../services/BrouillonService';
import { reorder, getMonthArrayFromDecimal, currencyFormat } from '../../../../helper/Helper'
import MdReader from '../../../../components/md-reader/MdReader';
import './BrouillonDetails.scss';
import { GlobalContext } from "../../../../services/GlobalProvider";
import Split from '../../../../components/split/Split';


const BrouillonDetails = (props) => {

    const [brouillon, setBrouillon] = useState()
    const [getBrouillonLoading, setGetBrouillonLoading] = useState()

    const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);

    useEffect(() => {
        setBrouillon()
        getBrouillon()
    }, [props.brouillonId]);

    function getBrouillon() {
        setGetBrouillonLoading(true)
        BrouillonService.getBrouillon(props.folderId, props.brouillonId).then(res => {
            setBrouillon(res.status == 200 ? res.data.data : { warning: res.statusText })
            setGetBrouillonLoading(false)
        }).catch(error => {
            setBrouillon({ error: error })
            setGetBrouillonLoading(false)
        });
    }

    return (

        <div id="BrouillonDetails">

            {(!brouillon && getBrouillonLoading) &&
                <span className="hloader mt-3"></span>
            }

            {brouillon?.warning &&
                <div className="d-inline-block w-100 mt-4">
                    <Alert variant="warning">
                        {brouillon?.warning}
                    </Alert>
                </div>
            }

            {brouillon?.error &&
                <div className="d-inline-block w-100 mt-4">
                    <ErrorManager error={brouillon?.error} />
                </div>
            }


            {(brouillon && !brouillon?.warning && !brouillon?.error) && (
                <>
                    <div className="d-flex mb-4">
                        <div className="me-auto">
                            <div className="me-3">
                                <h6 className="m-0">{brouillon?.client_nom}</h6>
                            </div>
                            <div className="me-3">
                                <Badge bg="light" text="dark" className="me-2">Type : {brouillon?.type}</Badge>
                                <Badge bg="light" text="dark" className="me-2">Date : {new Date(brouillon?.date).toLocaleString()}</Badge>
                            </div>
                        </div>
                        {props.elementActions.length > 0 &&
                            <Dropdown className="float-end ms-2 me-3">
                                <OverlayTrigger
                                    placement="left"
                                    delay={{ show: 800 }}
                                    overlay={
                                        <Tooltip>
                                            Plus d'actions
                                        </Tooltip>
                                    }
                                >
                                    <Dropdown.Toggle variant="secondary" className='no-btn-caret'>
                                        <i className="material-icons i-lg">more_horiz</i>
                                    </Dropdown.Toggle>
                                </OverlayTrigger>
                                <Dropdown.Menu>
                                    {props.elementActions.map((element) => (
                                        <Dropdown.Item key={element.title} onClick={() => props.setElementAction(element.action, brouillon)}>{element.title}</Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        }
                    </div>

                    <div className="light-v-scroll height-full-min-250 pe-2">
                        <Accordion defaultActiveKey={['description', 'brouillon', 'details', 'observations', 'adresse-livraison', 'adresse-facturation', 'client']} alwaysOpen>


                            <Accordion.Item eventKey="description" className="border-0 mb-3 text-break">
                                <Accordion.Header>Description</Accordion.Header>
                                <Accordion.Body className="px-1">
                                    {brouillon?.description &&
                                        <p>{brouillon?.description}</p>
                                    }
                                    {!brouillon?.description &&
                                        <em>- Aucune description rédigée -</em>
                                    }
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="client" className="border-0 mb-3">
                                <Accordion.Header>Client</Accordion.Header>
                                <Accordion.Body className="px-1">
                                    {brouillon?.client?._id && <Split title="Client" border value={<a href={`/${props.folderId}/clients?clientId=${brouillon?.client?._id}`} target="_blank">Afficher le client</a>} />}
                                    <Split border title="Nom" value={brouillon?.client?.nom} />
                                    <Split border title="Code" value={brouillon?.client?.code} />
                                    <Split border title="Profession" value={brouillon?.client?.profession} />
                                    <Split border title="Bloquer" value={brouillon?.client?.bloquer ? "Oui" : "Non"} />
                                    {brouillon?.client?.interlocuteurs.length > 0 &&
                                        <>
                                            <Split title="Interlocuteurs" value="" />
                                            {brouillon?.client?.interlocuteurs.map(interlocuteur => (
                                                <div key={interlocuteur._id} className="border px-3 py-2 rounded mb-3">
                                                    <Split title="Nom" value={interlocuteur.nom + (interlocuteur.principal ? " (Principal)" : "")} />
                                                    <Split title="Mails" value={
                                                        <>
                                                            {interlocuteur.mails.map(mail => (
                                                                <span key={mail} className="py-1 px-2 small rounded bg-gray-100 ms-2 mb-2 d-inline-flex">{mail}</span>
                                                            ))}
                                                        </>
                                                    } />
                                                </div>
                                            ))}

                                        </>


                                    }

                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="brouillon" className="border-0 mb-3">
                                <Accordion.Header>Brouillon</Accordion.Header>
                                <Accordion.Body className="px-1">
                                    <Split border title="Utilisateur" value={brouillon?.user} />
                                    <Split border title="Vendeur" value={brouillon?.vendeur} />
                                    <Split border title="Mention exonération" value={brouillon.mention_calc?.exoneration} />
                                    <Split border title="Mention historique" value={brouillon.mention_calc?.historique} />
                                    <Split border title="Date d'exécution" value={new Date(brouillon?.date_execution).toLocaleDateString()} />
                                    {brouillon?.comptabilisee == true &&
                                        <Split border title="Comptabilisée" value="Oui" />
                                    }
                                    {brouillon?.comptabilisee == false &&
                                        <Split border title="Comptabilisée" value="Non" />
                                    }
                                    {parametres?.general?.export_comptable.comptabilite_analytique &&
                                        <Split border title="Secteur analytique" value={brouillon?.secteur_analytique} />
                                    }
                                    <Split border title={`Total prix revient (${parametres?.general?.devise_dossier})`} value={currencyFormat(brouillon?.total_prix_revient)} />
                                    <Split border title={`Total brut hors taxes (${parametres?.general?.devise_dossier})`} value={currencyFormat(brouillon?.total_brut_ht)} />
                                    <Split border title={`Total net hors taxes (${parametres?.general?.devise_dossier})`} value={currencyFormat(brouillon?.total_net_ht)} />
                                    <Split border title={`Total remise (${parametres?.general?.devise_dossier})`} value={currencyFormat(brouillon?.total_remise)} />
                                    <Split border title={`Total TTC (${parametres?.general?.devise_dossier})`} value={currencyFormat(brouillon?.total_ttc)} />
                                    <Split border title="Taux de marge global" value={`${currencyFormat(brouillon?.taux_marge_global_calc)} %`} />
                                    <Split border title="Taux de marque global" value={`${currencyFormat(brouillon?.taux_marque_global_calc)} %`} />
                                    <Split border title="Coefficient global" value={currencyFormat(brouillon?.coefficient_global_calc)} />
                                    <Split border title="Statut" value={brouillon?.statut} />
                                    <Split title={`Total montant taxes (${parametres?.general?.devise_dossier})`} value={currencyFormat(brouillon?.total_taxes?.montant_total)} />
                                    <div className="">
                                        {brouillon?.total_taxes?.montants_details?.map(montant => (
                                            <Badge key={montant.contribution_id} bg="gray-200" text="dark" className="me-2">{montant.libelle}</Badge>
                                        ))}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="details" className="border-0 mb-3">

                                <Accordion.Header>Details</Accordion.Header>
                                <Accordion.Body className="px-1 overflow-auto bg-gray-100">

                                    {(brouillon?.details.length > 0) &&
                                        <div className="table-container mt-2">
                                            <Table borderless className="small w-100">
                                                <thead>
                                                    <tr className='text-gray-600 text-uppercase'>
                                                        <th>Code</th>
                                                        <th style={{ minWidth: 220 }}>Désignation</th>
                                                        <th>Qté</th>
                                                        <th>Prix H.T</th>
                                                        <th>Montant H.T</th>
                                                        <th>Taux remise</th>
                                                        <th>Montant remise</th>
                                                        <th>Taux contrib.</th>
                                                        <th>Montant contri.</th>
                                                        <th>Px. de revient</th>
                                                        <th>Px. de vente TTC</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="align-middle">
                                                    {brouillon?.details.map(d =>
                                                        <tr key={d._id}>
                                                            <td>{d.code}</td>
                                                            <td>
                                                                {d.article_id && <a href={`/${props.folderId}/articles/?articleId=${d.article_id}`}>{d.designation}</a>}
                                                                {!d.article_id && <span>{d.designation}</span>}
                                                            </td>
                                                            <td>{d.quantite}</td>
                                                            <td>{currencyFormat(d.prix_vente_ht)}</td>
                                                            <td>{currencyFormat(d.montant_net_ht)}</td>
                                                            <td>{d.remise?.taux}</td>
                                                            <td>{d.remise?.montant}</td>
                                                            <td>
                                                                {d.contributions?.map(c => (
                                                                    <span key={c.contribution_id} className="rounded bg-gray-300 px-1 me-1">
                                                                        {c.valeur}
                                                                    </span>
                                                                ))}
                                                            </td>
                                                            <td>
                                                                {d.contributions?.map(c => (
                                                                    <span key={c.contribution_id} className="rounded bg-gray-300 px-1 me-1">
                                                                        {currencyFormat(c.montant)}
                                                                    </span>
                                                                ))}
                                                            </td>
                                                            <td>{currencyFormat(d.prix_revient)}</td>
                                                            <td>{currencyFormat(d.montant_ttc)}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    }
                                    {(brouillon?.details.length == 0) &&
                                        <em>- Aucune ligne de détail n'a été saisie -</em>
                                    }
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="adresse-livraison" className="border-0 mb-3">
                                <Accordion.Header>Adresse de livraison</Accordion.Header>
                                <Accordion.Body className="px-1">
                                    <Split border title="Libelle" value={brouillon?.adresse_livraison?.libelle} />
                                    <Split border title="Adresse" value={brouillon?.adresse_livraison?.adresse} />
                                    <Split border title="Code postal" value={brouillon?.adresse_livraison?.code_postal} />
                                    <Split border title="Ville" value={brouillon?.adresse_livraison?.ville} />
                                    <Split border title="Pays" value={brouillon?.adresse_livraison?.pays} />
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="adresse-facturation" className="border-0 mb-3">
                                <Accordion.Header>Adresse de facturation</Accordion.Header>
                                <Accordion.Body className="px-1">
                                    <Split border title="Libelle" value={brouillon?.adresse_facturation?.libelle} />
                                    <Split border title="Adresse" value={brouillon?.adresse_facturation?.adresse} />
                                    <Split border title="Code postal" value={brouillon?.adresse_facturation?.code_postal} />
                                    <Split border title="Ville" value={brouillon?.adresse_facturation?.ville} />
                                    <Split border title="Pays" value={brouillon?.adresse_facturation?.pays} />
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="observations" className="border-0 mb-3">
                                <Accordion.Header>Observations</Accordion.Header>
                                <Accordion.Body className="px-1">
                                    {brouillon?.observation &&
                                        <MdReader mdData={brouillon?.observation} />
                                    }
                                </Accordion.Body>
                            </Accordion.Item>

                        </Accordion>
                    </div>
                </>
            )}
        </div>
    )

}

export default BrouillonDetails;

